export { default } from "./UpsertMailingList";



// WEBPACK FOOTER //
// ./src/mutations/UpsertMailingList/index.ts